module.exports = __webpack_public_path__ + "assets/img/Main material (5).60c6904e.jpg";